import React from "react";
import { Link } from "react-router-dom";
import OurImpact from "../../components/OurImpact";
import {
  ThankYouHero,
  ThankYouInner,
  ThankYouHeadline,
  ThankYouSubtext,
  GratitudeSection,
  GratitudeCard,
  GratitudeBody,
  GratitudeClosing,
  SignerName,
  SignerTitle,
  ButtonRow,
  HomeButton,
  CoursesButton
} from "./styled.components";

const Thankyou: React.FC = () => {
  return (
    <>
      <ThankYouHero>
        <ThankYouInner>
          <ThankYouHeadline>Thank you for Making a Difference</ThankYouHeadline>
          <ThankYouSubtext>
            Your generosity helps ensure that every school, every community, and
            every family has access to the training and tools that save lives.
          </ThankYouSubtext>
        </ThankYouInner>
      </ThankYouHero>

      <OurImpact
        heading="YOUR GIFT AT WORK"
        subtitle="Here is what your contribution makes possible!"
        variant="flat"
      />

      <GratitudeSection>
        <GratitudeCard>
          <GratitudeBody>
            Every contribution to the Kyah Rayne Foundation directly supports
            our work to make sure no child, staff member, or community member
            faces a food allergy emergency without someone nearby who is trained
            and prepared to act.
          </GratitudeBody>
          <GratitudeBody>
            Your donation funds courses, drives legislative change, and builds
            the partnerships that keep life-saving medications in schools and
            public spaces where they belong. We are grateful for your trust and
            your generosity.
          </GratitudeBody>
          <GratitudeClosing>With sincere gratitude,</GratitudeClosing>
          <SignerName>Lisa Jan Cohen</SignerName>
          <SignerTitle>Founder &amp; CEO, Kyah Rayne Foundation</SignerTitle>
        </GratitudeCard>
        <ButtonRow>
          <HomeButton as={Link} to="/" onClick={() => window.scrollTo(0, 0)}>
            Return to Home
          </HomeButton>
          <CoursesButton
            as={Link}
            to="/trainings"
            onClick={() => window.scrollTo(0, 0)}
          >
            Explore Our Courses
          </CoursesButton>
        </ButtonRow>
      </GratitudeSection>
    </>
  );
};

export default Thankyou;
